import { Feature, Geometry, Position } from "geojson";
import { LayerItem } from "src/app/instant-analysis/models/map-config";
import { ColorType } from "../../instant-analysis/models/color-type";


/**
 * Um projeto tem várias análises.
 */
export interface Projeto{

    /** */
    id:number;

    /** */
    nome: string;

    /** */
    id_app_user:number;

    /** */
    analises: Analise[]
}


/**
 * Dados salvos da visualização do mapa de análise instantânea / histórica.
 * Uma análise pertence a somente um Projeto.
 */
export class Analise{

    /** ID da análise */
    id: number;

    /** ID do projeto associado. */
    id_projeto: number;

    /** Tipo da análise (instantânea ou histórica) */
    tipo: TipoAnalise;

    /** Nome */
    nome : string;

    /** Valor do campo da data base (análise instantânea) 
     * ou data inicial (análise histórica). */
    data_inicio: string;

    /**  */
    hora_inicio: string;

    /** */
    get data_hora_inicio() {
        return `${this.data_inicio} ${this.hora_inicio}`;
    }

    /** Valor do campo da data final (análise histórica). */
    data_fim: string;

    /** */
    hora_fim: string;

    /** */
    get data_hora_fim() {
        return `${this.data_fim} ${this.hora_fim}`;
    }

    /** Tamanho da célula da grade do heatmap. */
    tilesize: number;

    /** Valor do campo do percentil inferior. */
    percentil_min: number;

    /** Valor do campo do percentil superior. */
    percentil_max: number;

    /** Valor do campo do número de horas da janela de ocorrências. */
    intervalo_horas_ocorrencias: number;

    /** Valor do campo de minutos da janela de ocorrências.  */
    intervalo_minutos_ocorrencias: number;

    /** Nome da coluna da resolução de tempo selecionada (ex. quinzemin, trintamin etc.). */
    coluna_selecionada: string;

    /** Lista de configurações de exibição das camadas. */
    camadas: LayerItem[];

    /** Lista das regiões poligonais desenhadas pelo usuário. */
    regioes: Feature<Geometry>[];

    porcentagem_completude: number;

    /**  */
    fonte_prefeitura_niteroi: boolean;

    /**  */
    fonte_cemaden: boolean;
}

/**
 * Enumeração dos tipos de análise
 */
export enum TipoAnalise {

    /** Análise Instantânea */
    INSTANTANEA = 1,

    /** Análise Histórica */
    HISTORICA = 2
}

/**
 * Configuração da exibição das camadas (ex. Estações, Vias, Bairros etc.).
 * Uma camada pertence a somente uma análise.
 */
export interface Camada {

    /** ID da camada. */
    id_camada: number;

    /** ID da análise. */
    id_analise: number;

    /** Indica se a camada está ativa ou não. */
    ativo: boolean;

    /** Coloração da camada (contínua ou discreta). */
    coloracao: ColorType;

    /** Tipo da camada (1 para relacionada a chuva, 2 para ocorrências). */
    tipo_camada: number;
}

/**
 * Região poligonal desenhada no mapa.
 * Uma Região pertence a somente uma Análise.
 */
export interface Regiao {

    /** ID de 32 caracteres do polígono desenhado, gerado pelo mapbox draw.  */
    id: string|number;

    /** ID da análise */
    id_analise: number;

    /** Nome dado à região. */
    nome: string;

    /** Coordenadas da região. */
    coordenadas: Position[][];
}
